import { useEffect } from "react";

export default function useScrollTopOnLoad() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
}
